export default {
	sell_property: {
		en: "Sell Property",
		ar: "بيع العقار",
	},
	property_photos: {
		en: "Property Photos",
		ar: "صور العقار",
	},
	property_description: {
		en: "Property Description",
		ar: "وصف العقار",
	},
	asking_price: {
		en: "Asking Price",
		ar: "السعر المطلوب",
	},
	amount_transfer_bank_account: {
		en: "Note: The amount will be transferred to the account with the details below.",
		ar: "سيتم تحويل المبلغ إلى الحساب ذو التفاصيل الموضحة أدناه",
	},
	account_holder_name: {
		en: "Account Holder's Name",
		ar: "اسم صاحب الحساب",
	},
	bank_country: {
		en: "Bank Country",
		ar: "دولة البنك",
	},
	iban: {
		en: "IBAN",
		ar: "رقم الآيبان",
	},
	buyer_information: {
		en: "Buyer Information",
		ar: "معلومات المشتري",
	},
	name_as_per_id: {
		en: "Name as per ID",
		ar: "الاسم حسب الهوية",
	},
	offer_period: {
		en: "Offer Period",
		ar: "فترة العرض",
	},
	invalid_iban: {
		en: "Invalid IBAN Number",
		ar: "رقم الحساب المصرفي الدولي الآيبان غير صحيح",
	},
	tc_error_msg: {
		en: "Please accept terms and conditions.",
		ar: "يرجى قبول الشروط والأحكام.",
	},
	req_sell_submitted: {
		en: "Your request for sell has been submitted for Buyer confirmation. Please check the progress in \"My Sell Requests\" Section",
		ar: "تم إرسال طلب البيع للتأكيد من قبل المشتري. يرجى التحقق من الطلبات المقدمة في قسم \"طلبات البيع الخاصة بي\"",
	},
	my_sell_requests: {
		en: "My Sell Requests",
		ar: "طلبات البيع الخاصة بي",
	},
	booking_ref_number: {
		en: "Booking Reference Number",
		ar: "رقم الحجز المرجعي",
	},
	reason_for_rejection: {
		en: "Reason for rejection",
		ar: "سبب الرفض",
	},
	tenancy_contact: {
		en: "This property has active Tenancy Contract.",
		ar: "هذا العقار لديه عقد الإيجار فعال.",
	},
	owner_details: {
		en: "Owner Details",
		ar: "تفاصيل المالك",
	},
	booking_details: {
		en: "Booking Details",
		ar: "تفاصيل الحجز",
	},
	terms_and_conditions: {
		en: "Terms and Conditions",
		ar: "الشروط والأحكام",
	},
	payment_receipts: {
		en: "Payment Receipts",
		ar: "إيصالات الدفع",
	},
	invoice_type: {
		en: "Invoice Type",
		ar: "نوع الفاتورة",
	},
	rejection_reason: {
		en: "Rejection Reason",
		ar: "سبب الرفض",
	},
	system_error: {
		en: "System Error",
		ar: "خطأ بالنظام",
	},
	transactions: {
		en: "Transactions",
		ar: "العمليات التجارية",
	},
	share: {
		en: "Share",
		ar: "إرسال لصديق",
	},
	cancel_request: {
		en: "Cancel Request",
		ar: "إلغاء الطلب",
	},
	review_request: {
		en: "Review",
		ar: "مراجعة",
	},
	property_proceed_to_payment: {
		en: "Proceed to payment",
		ar: "دفع الرسوم",
	},
	download_receipt: {
		en: "Download Receipt",
		ar: "تنزيل الإيصال",
	},
	download_certificate: {
		en: "Download Certificate",
		ar: "تنزيل الشهادة",
	},
	cancel_confirm: {
		en: "Are you sure you want to cancel this request?",
		ar: "هل أنت متأكد من أنك تريد إلغاء هذا الطلب؟",
	},
	req_cancelled_sucess: {
		en: "Your request has been canceled successfully.",
		ar: "تم إلغاء طلبك بنجاح.",
	},
	booking_request: {
		en: "Booking Request",
		ar: "طلب الحجز",
	},
	booking_request_desc: {
		en: "Please enter the Booking Reference number which you have received via email or SMS.",
		ar: "يرجى إدخال رقم الحجز المرجعي الذي تلقيته عبر البريد الإلكتروني أو الرسائل القصيرة.",
	},
	otp_send_to_mob_email: {
		en: "We have sent a one-time password to the email and phone number submitted by the seller.",
		ar: "لقد أرسلنا كلمة مرور لمرة واحدة إلى البريد الإلكتروني ورقم الهاتف الذي قدمه البائع.",
	},
	req_sell_rejected: {
		en: "Your reject request has been submitted successfully.",
		ar: "تم رفض الطلب بنجاح",
	},
	identity_number: {
		en: "Identity Number",
		ar: "رقم الهوية",
	},
	identity_expiry: {
		en: "Identity Expiry",
		ar: "انتهاء صلاحية الهوية",
	},
	communication_language: {
		en: "Preferred Language",
		ar: "اللغة المفضلة",
	},
	upload_buyer_doc: {
		en: "Upload Buyer Documents",
		ar: "تحميل مستندات المشترى",
	},
	req_sell_accepted: {
		en: "Booking request has been submitted successfully. This request will be sent to auditor for review.",
		ar: "تم إرسال طلب الحجز بنجاح. سيتم إرسال هذا الطلب إلى المدقق للمراجعة.",
	},
	procedure_number: {
		en: "Procedure Number",
		ar: "رقم الإجراء",
	},
	booking_amount: {
		en: "Booking Amount",
		ar: "مبلغ الحجز",
	},
	full_payment: {
		en: "Full Payment",
		ar: "دفع كامل",
	},
	select_amount: {
		en: "Select Amount",
		ar: "اختر المبلغ",
	},
	payable_amount: {
		en: "Payable Amount",
		ar: "المبلغ المستحق",
	},
	file_page_exceed: {
		en: "Selected file count exceeds the maximum allowed ~ pages.",
		ar: " يتجاوز عدد الملفات المحددة الحد الأقصى المسموح به من الصفحات ~.",
	},
	sell_request_success: {
		en: "Your request for sell has been submitted for Buyer confirmation. Please check the progress in \"My Sell Request\" section.",
		ar: "تم إرسال طلب البيع للتأكيد من قبل المشتري. يرجى التحقق من الطلبات المقدمة في قسم \"طلبات البيع الخاصة بي\"",
	},
	bank_details: {
		en: "Bank Details",
		ar: "تفاصيل البنك",
	},
	invalid_date_of_birth: {
		en: "Invalid Date of Birth",
		ar: "تاريخ ميلاد غير صالح"
	}
};
